import { SectionCard } from '../yeni-design/primitives';

/**
 * G4b/final-fix F-4 — TanStack v5'te bir sorgu HATA ile biterse `data` KALICI OLARAK `undefined`
 * kalır (`throwOnError:false`, `useStokSorgu`). Kartlar eskiden yalnız `q.data === undefined`
 * kontrolüyle "yükleniyor" sanıyordu — hata durumunda `BlokIskeleti` EBEDİYEN dönerdi (ne hata,
 * ne "—", ne yeniden dene). `BlokIskeleti`nin kardeşi: aynı `testid/baslik/altBaslik/yukseklik`
 * imzasını taşır (drop-in), yalnız içeriği kısa ve dürüst bir hata satırıdır — kart GİZLENMEZ.
 */
export function KartHatasi({
  testid,
  baslik,
  altBaslik,
  yukseklik,
  mesaj = 'Veri yüklenemedi.',
}: {
  testid: string;
  /** Tıkla-aç içindeki çağıranlar GEÇMEZ (BlokIskeleti ile AYNI kural). */
  baslik?: string;
  altBaslik?: string;
  yukseklik?: number;
  mesaj?: string;
}) {
  return (
    <div data-testid={testid} data-hata="true" className="h-full">
      <SectionCard className="h-full flex flex-col" bodyClass="p-5 flex-1 flex flex-col justify-center" title={baslik} subtitle={altBaslik}>
        <div style={yukseklik ? { minHeight: yukseklik } : undefined} className="flex items-center">
          <p role="alert" className="text-[13px] text-ink-500">
            {mesaj}
          </p>
        </div>
      </SectionCard>
    </div>
  );
}
